// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__2Ybne","footer":"ModalError_footer__IoHCA"};